import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../../theme";
import patterbackground from "../images/pattern.jpeg";

interface PersonaliseChoiceModalProps {
  open: boolean;
  onClose: () => void;
  onYes: () => void;
  onNo: () => void;
  isSubmitting: boolean;
}

const PersonaliseChoiceModal: React.FC<PersonaliseChoiceModalProps> = ({
  open,
  onClose,
  onYes,
  onNo,
  isSubmitting,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <Box
        sx={{
          position: "relative",
          p: 3,
          bgcolor: "#614338",
          color: "white",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${patterbackground})`,
            backgroundRepeat: "repeat",
            backgroundSize: "contain",
            opacity: 0.1,
            zIndex: 0,
          }}
        />
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography variant="h4" fontWeight="bold">
            Personalise Your Quote
          </Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{ opacity: 0.9, mt: 1, color: colors.primary[500] }}
        >
          Would you like a more Personalised quotation with specific details
          about your beloved?
        </Typography>
      </Box>
      <DialogContent sx={{ p: 4 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={onYes}
          sx={{
            py: 1.5,
            mb: 2,
            borderRadius: 2,
            background: colors.primary[400],
            color: "white",
            fontWeight: 600,
          }}
        >
          Yes, Personalise It
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={onNo}
          sx={{
            py: 1.5,
            borderRadius: 2,
            borderColor: "divider",
            color: "text.primary",
            backgroundColor: colors.primary[800],
            boxShadow: 0,
            fontWeight: 600,
          }}
        >
          {isSubmitting ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "center",
              }}
            >
              <CircularProgress size={20} />
              Submitting...
            </Box>
          ) : (
            "No, Continue Without"
          )}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default PersonaliseChoiceModal;
